import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import VHSStat, { IVHSStatProps } from '../VHSStat';
export interface IVHSStatsItems {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Count Up
	 */
	countUp?: IVHSStatProps;
	/**
	 *  Text
	 */
	text?: string;
}
export interface IVHSStatsProps extends IBaseElementProps {
	/**
	 * Items
	 */
	items?: IVHSStatsItems[];
}

/**
 * Stats
 * @block
 * @icon id
 */
const VHSStats: React.FC<IVHSStatsProps> = ({
	items = [],
	className,
	classNames = [],
}) => {
	return (
		<div className={className || cn('vhs-stats', ...classNames)}>
			<div className="vhs-stats__container">
				{items.length > 0 &&
					<div className="vhs-stats__items">
						{items.map(({countUp, heading, text}, index) => {
							if (index < 5) {
								return (
									<div key={index} className="vhs-stats__item">
										<div className="vhs-stats__heading">
											{heading ? (
												<>{heading}</>
											) : (
												<VHSStat
													{...countUp}
												/>
											)}
										</div>
										<div className="vhs-stats__text">{text}</div>
									</div>
								)}
							}
						)}
					</div>
				}
			</div>
		</div>
	);
};

export default VHSStats;
